import i18n from '../../language/index'
KindEditor.lang({
  align : i18n.t('components_my_rich_text_align_2423')
})

KindEditor.plugin('align', function(K) {
  let editor = this
  let name = 'align'

  let method = {
    'justifyleft': i18n.t('base_kindeditor_all_1503'),
    'justifycenter': i18n.t('base_options_config_1683'),
    'justifyright': i18n.t('base_kindeditor_all_1504'),
    'justifyfull': i18n.t('base_kindeditor_all_1505')
  }

  editor.plugin.align = {
    edit () {
      let menu = editor.createMenu({ name: name, width: 95 })
      K.each(method, function (key, value) {
        menu.addItem({
          title : value,
          checked : false,
          iconClass: `ke-icon-${key}`,
          click : function() {
            editor.exec(key).hideMenu()
          }
        })
      })
    }
  }

  editor.clickToolbar(name, editor.plugin.align.edit)
})


// WEBPACK FOOTER //
// ./src/components/my_rich_text/align.js